export default class AlignmentTune {
    static get isTune() {
      return true;
    }
  
    constructor({ data, api }) {
      this.api = api;
      this.data = data || { alignment: 'start' };
      this.wrapper = undefined;
  
      this.alignments = [
        {
          name: 'start',
          svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="16"><path d="M0 88C0 74.7 10.7 64 24 64H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 112 0 101.3 0 88zm0 96c0-13.3 10.7-24 24-24H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zM0 280c0-13.3 10.7-24 24-24H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24z"/></svg>`
        },
        {
          name: 'center',
          svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="16"><path d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zm96 96c0-17.7 14.3-32 32-32H320c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32zM0 320c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zm96 96c0-17.7 14.3-32 32-32H320c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32z"/></svg>`
        },
        {
          name: 'end',
          svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="16"><path d="M0 88C0 74.7 10.7 64 24 64H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 112 0 101.3 0 88zm128 96c0-13.3 10.7-24 24-24H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24zM0 280c0-13.3 10.7-24 24-24H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zm128 96c0-13.3 10.7-24 24-24H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24z"/></svg>`
        },
        {
          name: 'justify',
          svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="16"><path d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 224c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM0 352c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM0 480c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"/></svg>`
        }
      ];
    }
  
    render() {
      const wrapper = document.createElement('div');
      wrapper.classList.add('alignment-tune');
  
      this.alignments.forEach(({ name, svg }) => {
        const button = document.createElement('button');
        button.classList.add('alignment-button');
        button.innerHTML = svg;
  
        if (this.data.alignment === name) {
          button.classList.add('active');
        }
  
        button.addEventListener('click', () => {
          this.data.alignment = name;
          this._setAlignment();
          [...wrapper.children].forEach(btn => btn.classList.remove('active'));
          button.classList.add('active');
        });
  
        wrapper.appendChild(button);
      });
  
      this.wrapper = wrapper;
      return wrapper;
    }
  
    _setAlignment() {
      const index = this.api.blocks.getCurrentBlockIndex();
      if (index === undefined) return;
  
      const block = this.api.blocks.getBlockByIndex(index);
      const holder = block.holder;
  
      this.alignments.forEach(({ name }) => {
        holder.classList.remove(`align-${name}`);
      });
  
      holder.classList.add(`align-${this.data.alignment}`);
    }
  
    save() {
      return {
        alignment: this.data.alignment
      };
    }
  
    applyTune() {
      this._setAlignment();
    }
  }
  